<nv-form-field label="Status">
    <nv-dropdown [options]="options" (selectOption)="onChange($event)" [returnObject]="true"
        [selected]="selectedStatusOption?.key"></nv-dropdown>
    <nv-note *ngIf="showWarning" [priority]="warningPriority">{{ warningText }}</nv-note>
    <nv-note [priority]="infoPriority"> {{ infoText }} </nv-note>
</nv-form-field>
